import type { CSSProperties } from 'react';

import type { CollectionCardConfig, CollectionItem } from '@/lib/blocks/collection/blocks';

/** `data.type` on collection card sortables; grid DnD ignores these drags. */
export const EDITOR_COLLECTION_ITEM_DRAG_TYPE = 'collection-item' as const;

export type EditorCollectionItemDragData = {
  type: typeof EDITOR_COLLECTION_ITEM_DRAG_TYPE;
  /** Block stable id of the owning collection. */
  collectionStableId: string;
};

export interface SortableCollectionListBaseProps {
  items: CollectionItem[];
  cardConfig: CollectionCardConfig;
  cardPaddingClass: string | undefined;
  cardStyle: CSSProperties | undefined;
  collectionSortableGroup: string;
  collectionItemDragData: EditorCollectionItemDragData;
  disabled?: boolean;
  actionsDisabled?: boolean;
  selectedItemId: string | null;
  onUpdate: (updated: CollectionItem, commit?: boolean) => void;
  onDelete: (id: string) => void;
  onDuplicate: (id: string) => void;
  onSelectionChange: (id: string, selected: boolean) => void;
}
